import React from 'react';

const ResponsiveContext = React.createContext(null);

export default ResponsiveContext;
